import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-web',
  templateUrl: './web.component.html',
  styleUrls: ['./web.component.scss']
})
export class WebComponent implements OnInit {

  title = 'Web development | Bill\'s portfolio site';
  websites: Object;
  wordpress: Object;
  magento: Object;
  netsuite: Object;
  drupal: Object;
  dotnet: Object;
  id: string;
  total: any;
  objectKeys = Object.keys;
  public errorMsg;
  public selectedId;
  public checkSelected;

  constructor(public router: Router,
              private titleService: Title, 
              private metaService: Meta, 
              private route: ActivatedRoute, 
              private _http: HttpService) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {name: 'robots', content: 'index, follow'}
    ]);
    this.metaService.updateTag({name: 'keywords', content: 'Web development, Magento, WordPress, NetSuite, Drupal, Angular, React, HTML/CSS, PHP, JavaScript'});
    this.metaService.updateTag({name: 'description', content: 'Bill has experience of Web interface and function design. He is familiar with web design many softwares, such as Adobe Creative Suite. He proficients in various web development software and technology including Magento, WordPress, NetSuite, Drupal, Angular, React, HTML/CSS, PHP, JavaScript, and cross-browser compliant and mobile compatible. He was engaged in the computer software industry for more than 9 years in China.'});

    this._http.getWebsites('all',null).subscribe(
      data => {
        this.websites = data;
        this.wordpress = data.filter((item) => { return item['item_category'] === 'WordPress' });
        this.magento = data.filter((item) => { return item['item_category'] === 'Magento' });
        this.netsuite = data.filter((item) => { return item['item_category'] === 'NetSuite' });
        this.drupal = data.filter((item) => { return item['item_category'] === 'drupal' });
        this.dotnet = data.filter((item) => { return item['item_category'] === '.Net' });
        // console.log(this.websites);
        this.total = Object.keys(data).length;
      },
      error => this.errorMsg = error      
    );
    
  }

  onSelect(website) {
    // this.router.navigate(['/list', brew.id]); // Absolute url
    this.router.navigate([website.url, {type: website.item_category, postType: 'websites'}], {relativeTo: this.route}); // relative url
  }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 1500,
    navText: ['<', '>'],
    autoplay:true,
    animateIn: 'fadeIn', 
    animateOut: 'fadeOut',
    responsive: {
      0: {
        items: 1 
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: false
  }

}
